<template>
    <form-modal
        :open="isEditModalOpen"
        :heading="$t('modals.subcategory.edit')"
        entity="subcategory"
        mode="edit"
        :submit-label="$t('modals.subcategory.save')"
        :fields="fields"
        :values="subcategory"
        :info="[{ label: $t('fields.id'), value: subcategory.subcategory_id }]"
        save-url="/edit-subcategory.php"
        :build-payload="buildPayload"
        @update:open="$emit('update:isEditModalOpen', $event)"
        @opened="load"
        @saved="$emit('subcategory-saved')"
    />
</template>

<script>
import { ref, computed } from 'vue';
import apiClient from '@/api/apiClient';
import { useCategoryOptions } from '@/composables/useCategoryOptions';
import FormModal from '@/components/common/FormModal.vue';
import { t } from '@/i18n';

export default {
    components: {
        FormModal,
    },
    props: {
        isEditModalOpen: {
            type: Boolean,
            required: true,
        },
        selectedSubcategory: {
            type: Object,
            default: () => ({ subcategory_id: null, subcategory_name: null, category_id: null }),
        },
    },
    emits: ['update:isEditModalOpen', 'subcategory-saved'],
    setup(props) {
        const subcategory = ref({});
        const { categoryOptions, fetchCategories } = useCategoryOptions();

        const fields = computed(() => [
            { key: 'subcategory_name', label: t('fields.subcategoryName'), type: 'text', required: true },
            { key: 'category_id', label: t('fields.category'), type: 'select', required: true, placeholder: t('placeholders.selectCategory'), options: categoryOptions.value },
        ]);

        const buildPayload = (form) => ({
            subcategoryId: form.subcategory_id,
            subcategoryName: form.subcategory_name,
            categoryId: form.category_id,
        });

        const load = () => {
            subcategory.value = {};
            fetchCategories();
            apiClient.get('/get-subcategory-details.php?subcategoryId=' + props.selectedSubcategory.subcategory_id)
                .then((response) => {
                    subcategory.value = response.data;
                })
                .catch((error) => {
                    console.error('Error fetching subcategory details:', error);
                });
        };

        return { subcategory, fields, buildPayload, load };
    },
};
</script>
